<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Bhakti Promotion
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="OpenAddDataModal">Add New
            Promotion</vs-button>
        </h3>
        <vs-row>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Status Filter" v-model="search.is_active" @change="fetchAllPromotionData">
              <vs-select-item value="" text="All" />
              <vs-select-item value="active" text="Active" />
              <vs-select-item value="inactive" text="Inactive" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Language Filter" v-model="search.app_language" @change="fetchAllPromotionData">
              <vs-select-item :key="index" :value="item.culture" :text="item.culture"
                v-for="(item, index) in languages" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="mt-2">
            <vs-input class="" label="Start Date" type="date" v-model="search.start_date"
              @change="fetchAllPromotionData" />
          </vs-col>
          <vs-col vs-lg="2" vs-xs="12" class="mt-2">
            <vs-input label="End Date" type="date" v-model="search.end_date" @change="fetchAllPromotionData" />
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" class="button-col mt-3">
            <!-- <vs-button color="primary" type="filled" icon="search" @click="fetchAllPromotionData()">Search</vs-button> -->

            <vs-button color="warning" type="filled" icon="cached" @click="resetData()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th></th>
            <th>Title</th>
            <th>Language</th>
            <th @click="sortByDate('startDate')" style="cursor: pointer;"> Start Date
              <span v-if="sortByField === 'startDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="sortByDate('endDate')" style="cursor: pointer;">End Date
              <span v-if="sortByField === 'endDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="sortBy('status')" style="cursor: pointer;">Status
              <span v-if="sortByField === 'status'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th></th>
          </tr>
          <tr v-for="(singleData, index) in promotionData" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <img v-if="
                singleData.background_url == '' ||
                singleData.background_url == null
              " src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="singleData.background_url" height="50px" width="75px" />
            </td>
            <td class="td">{{ singleData.title }}</td>
            <td class="td text-center">
              {{ singleData.app_language }}
              <div class="d-flex" v-if="search.app_language == 'EN' && singleData.languageCount">
                <div class="progress-bar-container mt-3">
                  <div class="progress-bar p-2" :style="{
                    color: singleData.languageCount - singleData.missingLanguages.length === singleData.languageCount ? 'white' : 'black',
                    backgroundColor: singleData.missingLanguages.length > 0 ? 'red' : singleData.missingLanguages.length > 1 ? '#06b800' : '',
                    width:
                      ((singleData.languageCount - singleData.missingLanguages.length) / singleData.languageCount) * 100 + '%'
                  }">
                    <div class="absoluteText">
                      {{ singleData.languageCount - singleData.missingLanguages.length }}/{{ singleData.languageCount }}
                    </div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800;">
                  <div style="width: 20px; height: 20px; margin-left: 5px"
                    v-popover:tooltip="singleData.tooltipContent">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="td">{{ moment(singleData.start_date) }}</td>
            <td class="td">{{ moment(singleData.end_date) }}</td>
            <td class="td">
              <vs-chip v-if="singleData.is_active" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>

            <td class="td">
              <vs-button class="mr15 mt-1" icon="create" size="small" color="warning"
                @click="editingData(singleData)">Edit</vs-button>
              <vs-button class="mr15 mt-1" size="small" color="danger" icon="delete_sweep" @click="
                deletePromotionDataPopup = true;
              dataToDelete = singleData._id;
              ">
                Delete
              </vs-button>
            </td>
          </tr>
        </table>

        <!-- Code -->
        <!-- Edit or Add Data Popup  -->
        <vs-popup :title="isNew ? 'Add New Promotion' : 'Edit Promotion'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select :color="colorx" label="Category Language" v-model="singleDataDetails.app_language"
                @change="fileterusingLanguage($event, singleDataDetails)" icon="arrow_downward"
                :disabled="isNew == true">
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages"
                  :key="index" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Enter Title" v-model="singleDataDetails.title" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input label="Enter Description" v-model="singleDataDetails.description" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-input label="Enter Price" type="number" :min="0" onwheel="this.blur()"
                v-model="singleDataDetails.price" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-input label="Enter Discounted Price" type="number" :min="0" onwheel="this.blur()"
                v-model="singleDataDetails.discount_price" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-input label="Enter Start Date" type="date" v-model="singleDataDetails.start_date" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-input label="Enter End Date" type="date" v-model="singleDataDetails.end_date" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12">
              <vs-input label="Enter Forwad Link URL" type="url" v-model="singleDataDetails.link_url" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="button-col">
              <vs-checkbox v-model="singleDataDetails.is_active">Status (Active / Inactive)</vs-checkbox>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Promotion BG Image (Try to use square image)</label>
                    <div class="btn">
                      <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File
                    </div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn"
                    @click="deleteImage()"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button icon="save" @click="addPromotionData">{{ isNew ? 'Save English' : 'Update one' }}</vs-button>
              <vs-button class="ml-3" icon="save" v-if="isNew" @click="createAndTranslate">Save and
                Translate</vs-button>
              <vs-button class="ml-3" v-if="!isNew && !showLoader && singleDataDetails.app_language === 'EN'"
                icon="save" @click="updateAndTranslate">Update all and Translate</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <!-- Delete Popup  -->
        <vs-popup class="holamundo" title="Delete Promotion Data" :active.sync="deletePromotionDataPopup">
          <p>Are you sure you want to delete the Promotion Data?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deletePromotionData">Delete Promotion Data</vs-button>
            <vs-button icon="clear" @click="deletePromotionDataPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true" ref="tooltipComponent">
    </tooltip>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "../../../common/constants";
import moment from "moment";
import Vue from 'vue'
import VPopover from 'vue-js-popover'

Vue.use(VPopover, { tooltip: true })

export default {
  name: "BhaktiPromotion",
  components: {},
  data: () => ({
    title: "",
    colorx: "#0D2144",
    defaultalert: false,
    isNew: true,
    languages: [],
    fileName: "",
    sortByField: "",
    sortDirection: "asc",
    search: {
      start_date: null,
      end_date: null,
      is_active: "",
      app_language: "EN",
    },
    promotionData: [],
    singleDataDetails: {
      title: "",
      background_url: "",
      description: "",
      price: "",
      discount_price: "",
      start_date: moment.utc(new Date()).format("YYYY-MM-DD"),
      end_date: moment.utc(new Date()).format("YYYY-MM-DD"),
      link_url: "",
      is_active: true,
      app_language: "EN",
    },
    displayImage: "",
    deletePromotionDataPopup: false,
    dataToDelete: "",
    datatoEdit: "",
    showLoader: false,
  }),
  computed: {
    sortedData() {
      return this.promotionData.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
        } else {
          return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
        }
      });
    },
  },
  methods: {
    sortBy(field) {
      this.sortByField = field;
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      this.promotionData = this.promotionData.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[field] > b[field] ? 1 : -1;
        } else {
          return a[field] < b[field] ? 1 : -1;
        }
      });
    },
    sortByDate(field) {
      this.sortByField = field;
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      this.promotionData = this.promotionData.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return new Date(a[field]) < new Date(b[field]) ? 1 : -1;
        } else {
          return new Date(a[field]) > new Date(b[field]) ? 1 : -1;
        }
      });
    },
    moment: function (date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },
    fetchAllPromotionData() {
      this.$vs.loading();
      api
        .get(API.GET_PROMOTION_DATA, {
          params: this.$data.search,
        })
        .then((r) => {
          this.$vs.loading.close();

          if (this.$data.search.app_language === 'EN' && r.data) {
            for (const item of r.data) {
              item.tooltipContent = item.missingLanguages.length > 0 ? 'Missing Languages: ' + item.missingLanguages.join(', ') : 'All Languages are translated';
            }
          }

          this.$data.promotionData = r.data;
          const targetId = this.$route.query.id;
          if (targetId) {
            const targetData = this.$data.promotionData.find((item) => item._id === targetId);
            if (targetData) {
              this.editingData(targetData);
            }
          }
          console.log("All Data",this.$data.promotionData);
          if (!r.status) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("bhaktiPromotion", this.$data.singleDataDetails.title);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();

      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage = response.data.files[0].url;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => { });
      this.$vs.loading.close();
    },
    OpenAddDataModal() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.singleDataDetails = {
        title: "",
        background_url: "",
        description: "",
        price: "",
        discount_price: "",
        start_date: moment.utc(new Date()).format("YYYY-MM-DD"),
        end_date: moment.utc(new Date()).format("YYYY-MM-DD"),
        link_url: "",
        is_active: "",
        app_language: "EN",
      };
      this.$data.displayImage = "";
    },
    addPromotionData() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      const promotionData = {
        background_url: this.$data.displayImage,
        title: this.$data.singleDataDetails.title,
        description: this.$data.singleDataDetails.description,
        link_url: this.$data.singleDataDetails.link_url,
        start_date: new Date(
          this.$data.singleDataDetails.start_date
        ).toISOString(),
        end_date: new Date(this.$data.singleDataDetails.end_date).toISOString(),
        is_active: this.$data.singleDataDetails.is_active,
        price: parseInt(this.$data.singleDataDetails.price),
        discount_price: parseInt(this.$data.singleDataDetails.discount_price),
        app_language: this.$data.singleDataDetails.app_language,
      };

      this.$vs.loading();
      if (this.$data.isNew === true) {
        api.post(`${API.ADD_PROMOTION_DATA}`, promotionData, { headers: headers, })
          .then((r) => {
            this.$vs.loading.close();
            if (r.status) {
              this.$vs.notify({
                title: "Added Promotion Data",
                text: "Added Promotion Data",
                color: "success",
                position: "top-right",
              });
              this.$data.defaultalert = false;
              this.fetchAllPromotionData();
            }
            if (!r.status) {
              this.$vs.notify({
                title: "Could not add Data",
                text: "Could not add Data",
                color: "danger",
                position: "top-right",
              });
            }
          })
          .catch(() => { });
      } else {
        console.log("Editing");
        api.put(`${API.EDIT_PROMOTION_DATA}/${this.singleDataDetails._id}`, promotionData, { headers: headers, })
          .then((r) => {
            this.$vs.loading.close();
            if (r.status) {
              this.$vs.notify({
                title: "Edited Promotion Data",
                text: "Edited Promotion Data",
                color: "success",
                position: "top-right",
              });
              this.$data.defaultalert = false;
              this.fetchAllPromotionData();
              if(this.$route.query.id){
                this.$router.push({ path: '/calendar' });
              }
            } else {
              this.$vs.notify({
                title: "Could not edit Data",
                text: "Could not edit Data",
                color: "danger",
                position: "top-right",
              });
            }
          })
          .catch(() => { });
      }
    },

    async createAndTranslate() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      const promotionData = {
        background_url: this.$data.displayImage,
        title: this.$data.singleDataDetails.title,
        description: this.$data.singleDataDetails.description,
        link_url: this.$data.singleDataDetails.link_url,
        start_date: new Date(
          this.$data.singleDataDetails.start_date
        ).toISOString(),
        end_date: new Date(this.$data.singleDataDetails.end_date).toISOString(),
        is_active: this.$data.singleDataDetails.is_active,
        price: parseInt(this.$data.singleDataDetails.price),
        discount_price: parseInt(this.$data.singleDataDetails.discount_price),
        app_language: this.$data.singleDataDetails.app_language,
      };

      this.$data.showLoader = true;
      this.$data.defaultalert = false;
      const res = await api.post(API.C_AND_T_PROMOTION_DATA, promotionData, { headers: headers, })
      try {
        if (res.status === 200) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Added Promotion Data",
            text: "Added Promotion Data",
            color: "success",
            position: "top-right",
          });
          this.$data.defaultalert = false;
          this.fetchAllPromotionData();
          this.$data.showLoader = false;
        }

      } catch (error) {
        this.$vs.notify({
          title: "Could not add Data",
          text: "Could not add Data",
          color: "danger",
          position: "top-right",
        });
        this.$data.showLoader = false;
        throw error;
      }
    },

    async updateAndTranslate() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      const promotionData = {
        background_url: this.$data.displayImage,
        title: this.$data.singleDataDetails.title,
        description: this.$data.singleDataDetails.description,
        link_url: this.$data.singleDataDetails.link_url,
        start_date: new Date(
          this.$data.singleDataDetails.start_date
        ).toISOString(),
        end_date: new Date(this.$data.singleDataDetails.end_date).toISOString(),
        is_active: this.$data.singleDataDetails.is_active,
        price: parseInt(this.$data.singleDataDetails.price),
        discount_price: parseInt(this.$data.singleDataDetails.discount_price),
        app_language: this.$data.singleDataDetails.app_language,
      };

      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      try {
        const r = await api.put(`${API.U_AND_T_PROMOTION_DATA}/${this.singleDataDetails._id}`, promotionData, { headers: headers, })
        if (r.status === 200) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Edited Promotion Data",
            text: "Edited Promotion Data",
            color: "success",
            position: "top-right",
          });
          this.$data.defaultalert = false;
          this.$data.showLoader = false;
          this.fetchAllPromotionData();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Could not edit Data",
          text: "Could not edit Data",
          color: "danger",
          position: "top-right",
        });
        this.$data.showLoader = false;
        throw error;
      }
    },

    fileterusingLanguage(event, item) {
      let id = item.ref || item._id;

      if (event && id) {
        this.$vs.loading();
        api
          .get(API.GET_SINGLE_PROMOTION_DATA, {
            params: {
              app_language: event,
              id: id,
            },
          })
          .then((r) => {
            this.$data.singleDataDetails = Object.assign({}, r.data);
            this.$data.displayImage = r.data.background_url;
            this.$data.singleDataDetails.start_date = moment
              .utc(new Date(r.data.start_date))
              .format("YYYY-MM-DD");
            this.$data.singleDataDetails.end_date = moment
              .utc(new Date(r.data.end_date))
              .format("YYYY-MM-DD");
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    editingData(i) {
      this.$data.isNew = false;
      this.$data.singleDataDetails = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.displayImage = i.background_url;
      this.$data.singleDataDetails.start_date = moment
        .utc(new Date(i.start_date))
        .format("YYYY-MM-DD");
      this.$data.singleDataDetails.end_date = moment
        .utc(new Date(i.end_date))
        .format("YYYY-MM-DD");
    },
    deletePromotionData() {
      api
        .delete(`${API.DELETE_PROMOTION_DATA}/${this.$data.dataToDelete}`)
        .then((r) => {
          if (r.status) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
            this.fetchAllPromotionData();
          }
          this.$data.deletePromotionDataPopup = false;
        })
        .catch(() => {
          this.$vs.notify({
            text: "Already Deleted",
            color: "danger",
            position: "top-right",
          });
          this.$data.deletePromotionDataPopup = false;
        });
    },
    deleteImage() {
      this.$data.displayImage = "";
    },
    resetData() {
      this.$data.search = {
        start_date: null,
        end_date: null,
        is_active: "",
        app_language: "EN",
      };
      this.fetchAllPromotionData();
    },
  },

  created() {
    this.fetchAllPromotionData();
    this.fetchAllLanguages();
    if(this.$route.query.language) {
      this.$data.search.app_language = this.$route.query.language;
      this.fetchAllPromotionData();
    }
  },
};
</script>

<style scoped>
.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mr15 {
  margin-right: 15px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.button-col {
  display: flex;
  align-items: center;
  gap: 5px;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
